import React, { Component } from 'react';
import BuscadorCargoAjuste from './BuscadorCargoAjuste';
import TablaAjusteCargoMotivo from './TablaAjusteCargoMotivo';

class FiltrosCargoAjuste extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { filtrarMovimientosPorDescripcion, abrirModal, destildarTildarCheckAllFiltroAjusteCargo, destildarTildarCheckFiltroAjusteCargo } = this.props.actions;
        const { dataModalFiltrosCargoAjuste, ajusteCargocheckConfirmarAll, idChecksAjusteCargoArray, 
                movimientosFiltradosPorDescripcion,movimientosFiltradosParaMostrarPanel, rdButtonAjusteCargo } = this.props.data;

        let titulo = rdButtonAjusteCargo == 'A' ? "Motivo de Ajuste" : "Concepto de cargo";
        
        return (
            <div className='modalContainer'>
                <div className="modal-filtros-ajuste-cargo">
                    <div className="modal-content">
                        <div className="modal-header-filtros-ajuste-cargo">
                            <div className="close-modal-filtros-ajuste-cargo" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => abrirModal(false,2)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">{titulo}</h2>
                        </div>
                        <div className="modal-body-filtros-ajuste-cargo">
                            <div className="modal-body-container-cambiar-estados">
                                <BuscadorCargoAjuste filtrarMovimientosPorDescripcion={filtrarMovimientosPorDescripcion} movimientosFiltradosPorDescripcion={movimientosFiltradosPorDescripcion} destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo} idChecksAjusteCargoArray={idChecksAjusteCargoArray} ajusteCargocheckConfirmarAll={ajusteCargocheckConfirmarAll} dataModalFiltrosCargoAjuste={dataModalFiltrosCargoAjuste} destildarTildarCheckAllFiltroAjusteCargo={destildarTildarCheckAllFiltroAjusteCargo} />
                                <div className="modal-cambiar-estados-separador"/>
                                <TablaAjusteCargoMotivo movimientosFiltradosParaMostrarPanel={movimientosFiltradosParaMostrarPanel} destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FiltrosCargoAjuste;